import React from 'react';
import { connect } from 'react-redux';

import { getUser } from '../User/userSelectors';

const INTERCOM_APP_ID = process.env.REACT_APP_INTERCOM_APP_ID;

class Footer extends React.Component {
  componentDidMount() {
    window.intercomSettings = {
      api_base: 'https://api-iam.intercom.io',
      app_id: INTERCOM_APP_ID,
    };
    this.setIntercomSettings();
  }

  componentDidUpdate(prevProps) {
    const { user } = this.props;
    if ((!user || !user.id) && prevProps.user.id) {
      window.Intercom('shutdown');
      return;
    }

    if (user.id !== prevProps.user.id) {
      window.Intercom('update', {
        hide_default_launcher: false,
        username: user.username,
        user_hash: user.user_hash,
        name: `${user.name} ${user.lastName}`,
        email: user.email,
        phone:
          user.countryCode && user.phoneNumber
            ? user.countryCode + user.phoneNumber
            : '',
        created_at: Math.floor(user.createdAt / 1000),
        rating_exam: user.ratingExam,
        duty_status: user.rank,
        exam_type: user.dutyState,
        signed_up_at: Math.floor(user.createdAt / 1000),
        rate: user.rate ? user.rate.name : '',
        bluejacketeer_id: user.id,
        sentry_link: `https://sentry.io/serfre/bluejacketeer/?query=user%3Aid%3A${user.id}`,
        sub_platform: user.transactionIosId ? 'iOS' : 'Stripe',
      });
    }
  }

  setIntercomSettings = () => {
    (function () {
      const w = window;
      const ic = w.Intercom;
      if (typeof ic === 'function') {
        ic('reattach_activator');
        ic('update', w.intercomSettings);
      } else {
        const d = document;
        const i = function () {
          i.c(arguments);
        };
        i.q = [];
        i.c = function (args) {
          i.q.push(args);
        };
        w.Intercom = i;
        function l() {
          const s = d.createElement('script');
          s.type = 'text/javascript';
          s.async = true;
          s.rel = 'preconnect';
          s.id = 'intercom-script-id';
          s.src = `https://widget.intercom.io/widget/${INTERCOM_APP_ID}`;
          const x = d.getElementsByTagName('script')[0];
          x.parentNode.insertBefore(s, x);
        }
        if (w.attachEvent) {
          w.attachEvent('onload', l);
        } else {
          w.addEventListener('load', l, false);
        }
      }
    })();
  };

  onClickFacebook = () => {
    window.location.href = 'https://www.facebook.com/promotionwingman';
  };

  onClickInstagram = () => {
    window.location.href = 'https://www.instagram.com/promotionwingman/';
  };

  onClickTwitter = () => {
    window.location.href = 'https://twitter.com/promotionwingman';
  };

  render() {
    return <div />;
  }
}

const mapStateToProps = (state, ownProps) => ({
  user: getUser(state),
});

export default connect(mapStateToProps)(Footer);
